/** Signals — create view (delegates to the shared SignalForm). */
import { SignalForm } from "./_SignalForm";

export function SignalCreate() {
  return <SignalForm action="create" />;
}

export default SignalCreate;
